module.exports = __webpack_public_path__ + "static/media/icon-3@2x.7383a7dc.png";